// import { createSlice } from "@reduxjs/toolkit";
// import {
//   fetchWarehouseDropdown
// } from "./thunk";

// interface UnitState {
//   list: any[];
//   loading: boolean;
//   error: string | null;
//   selected: any | null;
// }

// const initialState: UnitState = {
//   list: [],
//   loading: false,
//   error: null,
//   selected: null,
// };

// const wharehouseDropdownSlice = createSlice({
//   name: "WarehouseDropdown",
//   initialState,
//   reducers: {
//     setSelectedWarehouse: (state, action) => {
//       state.selected = action.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchWarehouseDropdown.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchWarehouseDropdown.fulfilled, (state, action) => {
//         state.loading = false;
//         state.list = action.payload.data;
//         state.selected = action.payload.data[0];
//       })
//       .addCase(fetchWarehouseDropdown.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message || "Failed to fetch Warehouser Dropdown";
//       })
//   },
// });
// export const { setSelectedWarehouse } = wharehouseDropdownSlice.actions;
// export default wharehouseDropdownSlice.reducer;



import { createSlice, createSelector } from "@reduxjs/toolkit";
import { fetchWarehouseDropdown } from "./thunk";

interface UnitState {
  list: any[];
  loading: boolean;
  error: string | null;
  selected: any | null;
}

const initialState: UnitState = {
  list: [],
  loading: false,
  error: null,
  selected: null,
};

const warehouseDropdownSlice = createSlice({
  name: "WarehouseDropdown",
  initialState,
  reducers: {
    setSelectedWarehouse: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.selected = null;
        state.list = action.payload.data;
        // Default to first item if not already selected
        console.log("action.payload.data[0] : ",action.payload.data)
        state.selected = action.payload.data[0];
        // if (!state.selected) {
        // }
      })
      .addCase(fetchWarehouseDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Warehouse Dropdown";
      });
  },
});

export const { setSelectedWarehouse } = warehouseDropdownSlice.actions;
export default warehouseDropdownSlice.reducer;

// Optional: Selector for component usage
export const selectWarehouseDropdown = createSelector(
  (state: any) => state.warehouseDropdownReducer,
  (data) => ({
    warehouseDropdownList: data.list,
    warehouseDropdownLoading: data.loading,
    warehouseDropdownError: data.error,
    selectedWarehouse: data.selected,
  })
);
